import { bool, string, func, object } from "prop-types";

const propTypes = {
  includeSearchBar: bool.isRequired,
  searchPlaceholder: string.isRequired,
  searchRef: object.isRequired,
  handleKeyDown: func.isRequired,
  searchTerm: string.isRequired,
  setSearchTerm: func.isRequired,
  searchIcon: object.isRequired,
  clearAllFacets: func.isRequired,
};

export const SearchBar = (props) => {
  const {
    includeSearchBar,
    searchPlaceholder,
    searchRef,
    handleKeyDown,
    searchTerm,
    setSearchTerm,
    searchIcon,
    clearAllFacets,
  } = props;

  return (
    includeSearchBar && (
      <div className="faculty-directory-listing__search">
        <input
          className="faculty-directory-listing__search-input"
          placeholder={searchPlaceholder}
          ref={searchRef}
          onKeyDown={handleKeyDown}
          defaultValue={searchTerm}
        ></input>

        {searchRef.current?.value !== "" && (
          <button
            title="Clear search term"
            onClick={(e) => {
              e.preventDefault();
              setSearchTerm("");
              searchRef.current.value = "";

              // Handle special case where we may have a search term coming from global search
              const url = new URL(window.location.href);
              const params = new URLSearchParams(url.search);
              const queryParam = params.get("q");

              // If there is an initial search term,
              // delete it from the URL (to match component search bar behavior)
              if (queryParam) {
                params.delete("q");
                url.search = params.toString();
                window.history.pushState({}, "", url);
              }
            }}
            className="academic-research-listing__clear-btn"
          >
            {closeIcon}
          </button>
        )}

        <button
          aria-label="Search"
          onClick={(event) => {
            event.preventDefault();
            searchRef.current.value !== searchTerm
              ? [clearAllFacets(), setSearchTerm(searchRef.current.value)]
              : null;
          }}
          className="faculty-directory-listing__search-btn"
        >
          {searchIcon}
        </button>
      </div>
    )
  );
};

SearchBar.propTypes = propTypes;

const closeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-x"
  >
    <line x1="20" y1="6" x2="6" y2="20"></line>
    <line x1="6" y1="6" x2="20" y2="20"></line>
  </svg>
);
